export enum MemberViewType {
  subscriberView = 'subscriberView',
  dependentView = 'dependentView',
}
